import { Box, Button, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { useTranslation } from "@/translations";

import { useViennaAddressImport } from "./hooks/useViennaAddressImport";

function AddressesSettingsInner() {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const { triggerImport, isImporting, isStatusLoading, lastImportedAt } = useViennaAddressImport();

  const formattedDate = lastImportedAt
    ? format(lastImportedAt, "dd.MM.yyyy HH:mm", { locale: locales[language] })
    : null;

  return (
    <Stack sx={{ flex: 1 }} bgcolor="white">
      <Stack flex={1} gap={3} sx={{ overflowY: "auto" }}>
        <Typography variant="h5">{t("settings.addresses.title")}</Typography>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button variant="contained" onClick={() => triggerImport()} disabled={isImporting || isStatusLoading}>
            {isImporting ? t("settings.addresses.importing") : t("settings.addresses.importButton")}
          </Button>
          <Box>
            {formattedDate ? (
              <Typography variant="body2" color="text.secondary">
                {t("settings.addresses.lastImport", { date: formattedDate })}
              </Typography>
            ) : (
              <Typography variant="body2" color="text.secondary">
                {t("settings.addresses.neverImported")}
              </Typography>
            )}
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
}

export const AddressesSettings = withAuthorization(AddressesSettingsInner, UserPermission.Supervisor);
